import { gql, QueryHookOptions, useQuery } from '@apollo/client';

export const GET_MY_NOTIFICATION_PREFERENCES = gql`
  query GetMyNotificationPreferences {
    getMyNotificationPreferences {
      pushNotifications
      exchangeUpdates
      newFollowers
      assetSaved
      chatMessages
    }
  }
`;

export interface NotificationPreferences {
  pushNotifications: boolean;
  exchangeUpdates: boolean;
  newFollowers: boolean;
  assetSaved: boolean;
  chatMessages: boolean;
}

export interface GetMyNotificationPreferencesResponse {
  getMyNotificationPreferences: NotificationPreferences;
}

export const useGetMyNotificationPreferences = (
  options?: QueryHookOptions<GetMyNotificationPreferencesResponse>,
) => {
  return useQuery<GetMyNotificationPreferencesResponse>(
    GET_MY_NOTIFICATION_PREFERENCES,
    options,
  );
};
